import { httpClient } from '@/lib/httpClient';

export interface Sale {
  id: number;
  orderId: string;
  creationDate: string;
  products: string[];
  categories: string[];
  value: number;
}

class SalesService {
  constructor() {}

  async findAllByUserProfileId(userProfileId: string) {
    const { data } = await httpClient.get<Sale[]>(
      `/v1/sales-history/user/${userProfileId}`,
    );

    return data;
  }
}

export default new SalesService();
